import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../components/SEO.jsx";

const GOOGLE_ADS_SEND_TO = "AW-17475314205/rvSnCL--uJ0cEJ3E8IxB";

export default function ThankYou() {
  const navigate = useNavigate();

  useEffect(() => {
    // Fire events
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "generate_lead");
      window.gtag("event", "conversion", {
        send_to: GOOGLE_ADS_SEND_TO,
      });
    }

    // Redirect after delay
    const timer = setTimeout(() => {
      navigate("/");
    }, 7000); // 7 seconds

    return () => clearTimeout(timer);
  }, [navigate]);

  // App.js already wraps every page in <main>. Top padding matches the other
  // page heroes (pt-28 / sm:pt-32) so content clears the fixed navbar.
  return (
    <section className="thankyou-page px-5 pb-20 pt-28 sm:pt-32">
      <SEO
        title="Thank you • 2merative Web Design"
        description="Thank you for contacting 2merative Web Design."
        path="/thank-you"
      />

      <div
        style={{
          maxWidth: "700px",
          margin: "0 auto",
          textAlign: "center",
          lineHeight: "1.6",
        }}
      >
        <h1 style={{ fontSize: "2.2rem", marginBottom: "20px" }}>
          Thank you from 2merative Web Design
        </h1>

        <p style={{ marginBottom: "16px" }}>
          Your submission has been received successfully.
        </p>

        <p style={{ marginBottom: "16px" }}>
          We will be in touch shortly to confirm next steps.
        </p>

        <p style={{ marginTop: "20px", fontSize: "0.9rem", opacity: 0.7 }}>
          You will be redirected shortly.
        </p>
      </div>
    </section>
  );
}